import React from 'react';
import BlockRenderer from './BlockRenderer';
import { isSelfContained, BG_PRESETS, SPACING_PRESETS, WIDTH_PRESETS } from './blockDefs';

const alignClass = (a) => (a === 'left' ? 'text-left' : a === 'right' ? 'text-right' : 'text-center');

// Renders one section's visible blocks. Self-contained section-type blocks render
// full-width and self-styled; generic blocks render inside a padded container grid.
export default function SectionRenderer({ section, ctx = {} }) {
  if (!section || section.visible === false) return null;
  const s = section.settings || {};
  const blocks = (section.blocks || []).filter((b) => b && b.visible !== false);
  if (!blocks.length) return null;

  const allSelfContained = blocks.every(isSelfContained);
  if (allSelfContained) {
    return <>{blocks.map((b) => <BlockRenderer key={b.id} block={b} ctx={ctx} />)}</>;
  }

  const cols = s.columns === 3 ? 'md:grid-cols-3' : s.columns === 2 ? 'md:grid-cols-2' : 'grid-cols-1';
  const bg = BG_PRESETS[s.bg] ?? '';
  const spacing = SPACING_PRESETS[s.spacing] ?? SPACING_PRESETS.normal;
  const width = WIDTH_PRESETS[s.width] ?? WIDTH_PRESETS.normal;

  return (
    <section className={`${bg} ${spacing}`}>
      <div className={`${width} mx-auto px-4 sm:px-6 lg:px-8 ${alignClass(s.align)}`}>
        <div className={`grid grid-cols-1 ${cols} gap-8 items-start`}>
          {blocks.map((b) => (
            <div key={b.id}>
              <BlockRenderer block={b} ctx={ctx} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
